/**
 * omit.js
 *
 * @Author: jruif
 * @Date: 2017/6/29 下午3:44
 */
import assign from 'object-assign';
import { isFunction } from './isType';

/*
* var object = { 'a': 1, 'b': '2', 'c': 3 };
* omit(object, ['a', 'c']); // => { 'b': '2' }
*
* */
function omit(obj, fields) {
    const copy = assign({}, obj);
    if (Array.isArray(fields)) {
        for (let i = 0; i < fields.length; i++) {
            const key = fields[i];
            delete copy[key];
        }
    } else if (isFunction(fields)) {
        for (const key in copy) {
            if (copy.hasOwnProperty(key) && fields(copy[key])) {
                delete copy[key];
            }
        }
    }
    return copy;
}

export default omit;



// WEBPACK FOOTER //
// ./src/util/omit.js